/* eslint-disable */

export const editDepthBotConstants = {
    EDIT_DEPTH_BOT_REQUEST: 'EDIT_DEPTH_BOT_REQUEST',
    EDIT_DEPTH_BOT_SUCCESS: 'EDIT_DEPTH_BOT_SUCCESS',
    EDIT_DEPTH_BOT_FAILURE: 'EDIT_DEPTH_BOT_FAILURE',
};
